// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "clipPlaneVertex";
const shader = `#ifdef CLIPPLANE
fClipDistance=dot(worldPos,vClipPlane);#endif
#ifdef CLIPPLANE2
fClipDistance2=dot(worldPos,vClipPlane2);#endif
#ifdef CLIPPLANE3
fClipDistance3=dot(worldPos,vClipPlane3);#endif
#ifdef CLIPPLANE4
fClipDistance4=dot(worldPos,vClipPlane4);#endif
#ifdef CLIPPLANE5
fClipDistance5=dot(worldPos,vClipPlane5);#endif
#ifdef CLIPPLANE6
fClipDistance6=dot(worldPos,vClipPlane6);#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export const clipPlaneVertex = { name, shader };
